import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Select, { MultiValue } from 'react-select';
import makeAnimated from 'react-select/animated';
import { SelectorOption } from 'types';

type Props = {
  selectedCategoryOptions: MultiValue<SelectorOption>;
  options: SelectorOption[];
  handleChangeCategories: (newValue: MultiValue<SelectorOption>) => void; // eslint-disable-line
};

const PersonalDataViewCategory: FC<Props> = ({
  selectedCategoryOptions,
  options,
  handleChangeCategories,
}) => {
  const { t } = useTranslate();

  const animatedComponents = makeAnimated();

  return (
    <div className="col-md-6">
      <div className="form-group">
        <label className="form-label" htmlFor="partner-category">
          {t('CategoriesHeader')}
        </label>

        <div id="partner-category" className="form-control-wrap">
          <Select
            closeMenuOnSelect={false}
            className="react-select"
            value={selectedCategoryOptions}
            options={options}
            components={animatedComponents}
            onChange={handleChangeCategories}
            placeholder={t('SelectCategories')}
            isMulti
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: '42px',
              }),
              valueContainer: (provided) => ({
                ...provided,
                minHeight: '42px',
                display: 'flex',
                alignItems: 'center',
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDataViewCategory;
